
import {
  LayoutDashboard,
  UserCog,
  ShieldCheck,
  Shield,
  DollarSign,
  Settings,
  Building2,
  Factory,
  FileEdit,
} from "lucide-react";
import { NavigationConfig } from "../types";

export const adminNavigation: NavigationConfig[] = [
  { 
    name: "Overview", 
    href: "/admin", 
    icon: LayoutDashboard,
    tooltip: "Dashboard Overview"
  },
  { 
    name: "User Management",
    href: "/admin/users/management",
    icon: UserCog,
    tooltip: "Comprehensive User Management"
  },
  { 
    name: "Verification Management",
    href: "/admin/verification/management",
    icon: ShieldCheck,
    tooltip: "ID and Document Verification"
  },
  { 
    name: "Risk Management",
    href: "/admin/risk/management",
    icon: Shield,
    tooltip: "Comprehensive Risk Management"
  },
  { 
    name: "Financial Management",
    href: "/admin/finance",
    icon: DollarSign,
    tooltip: "Comprehensive Financial Management"
  },
  { 
    name: "Lender Management",
    href: "/admin/lenders",
    icon: Building2,
    tooltip: "Comprehensive Lender Management"
  },
  { 
    name: "Vendor Management",
    href: "/admin/vendors",
    icon: Factory,
    tooltip: "Comprehensive Vendor Management"
  },
  { 
    name: "CMS",
    href: "/admin/cms",
    icon: FileEdit,
    tooltip: "Content Management System"
  },
  { 
    name: "Settings", 
    href: "/admin/settings", 
    icon: Settings,
    tooltip: "System Settings"
  },
];
